import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library
import { devConfig } from 'config/config'; // Importing development configuration from the config module

/**
 * Class representing a view for table expenses.
 * @extends JetView
 */
export default class tableExpensesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates in the datatable
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Preserve the context of 'this' for use in inner functions
        var vthis = this;
        return {
            view: 'datatable', // Define the view type as a datatable
            id: 'datatable', // Set the ID for the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // Apply CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Enable vertical scrolling based on screen width
            height: screen.width < 820 ? 410 : 0, // Set height based on screen width
            columns: [
                // Define the columns of the datatable
                {
                    id: 'rating', // Unique identifier for the column
                    header: '', // Header text for the column
                    width: 50, // Width of the column
                    height: 25, // Height of the column
                    tooltip: 'Editar', // Tooltip text for the column
                    template: function (obj) {
                        // Template function to render content
                        // Check permissions for editing
                        if (devConfig.getPermAction('accountingExpensePrint', 'Edit')) {
                            // Return an icon if the user has permission
                            return "<span class='webix_icon wxi-close printer'></span>";
                        } else {
                            // Return an empty string if no permission
                            return '';
                        }
                    },
                },
                {
                    id: 'Id', // Unique identifier for the column
                    header: 'ID', // Header text for the column
                    width: 100, // Width of the column
                    sort: 'int', // Sort type for the column
                    hidden: true, // Hide this column
                },
                {
                    id: 'Consecutive', // Unique identifier for the column
                    header: _('Consecutivo'), // Header text with localization
                    width: 100, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'Description', // Unique identifier for the column
                    header: _('Descripción'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'CreatedLocalDate', // Unique identifier for the column
                    header: _('Fecha de Creación'), // Header text with localization
                    fillspace: 0, // Fill space option
                    minWidth: 0, // Minimum width of the column
                    width: 150, // Width of the column
                    sort: 'text', // Sort type for the column
                    format: dateFormat, // Format for displaying dates
                },
                { id: 'UserId', header: _('ID Usuario'), width: 100 }, // User ID column
                {
                    id: 'BetShop', // Unique identifier for the column
                    header: _('Punto de Venta'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'UserCreated', // Unique identifier for the column
                    header: _('Creador'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                {
                    id: 'DocumentID', // Unique identifier for the column
                    header: _('Documento ID'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                { id: 'Account', header: _('Cuenta'), width: 150, sort: 'int' }, // Account column
                {
                    id: 'Concept', // Unique identifier for the column
                    header: _('Concepto'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
                { id: 'Amount', header: _('Valor'), width: 150, sort: 'int' }, // Amount column
                { id: 'Tax', header: _('Impuesto'), width: 150, sort: 'int' }, // Tax column
                {
                    id: 'Retraction', // Unique identifier for the column
                    header: _('Retracción'), // Header text with localization
                    width: 150, // Width of the column
                    sort: 'int', // Sort type for the column
                },
            ],
            onClick: {
                // Define click event handlers
                edit: function (euv, id) {
                    // Handler for edit button click
                    vthis.app.callEvent('openEdit', [{}]); // Trigger the openEdit event
                },
                printer: function (euv, id) {
                    // Handler for printer icon click
                    var vvthis = this; // Preserve context
                    var item = vvthis.getItem(id); // Get the clicked item
                    webix
                        .ajax() // Perform an AJAX request
                        .headers({
                            'Content-type': 'application/json', // Set content type for the request
                        })
                        .post(
                            devConfig.geturlApi() + 'Accounting/GetDetailsExpensePDF', // API endpoint
                            '{ "Id":' + item.Id + '}', // Request payload
                            {
                                error: function (text, data, XmlHttpRequest) {
                                    // Error handler
                                    webix.message(_('Error! ')); // Show error message
                                },
                                success: function (text, data, XmlHttpRequest) {
                                    // Success handler
                                    data = JSON.parse(text); // Parse the response data
                                    webix
                                        .ui({
                                            // Create a new window UI
                                            view: 'window',
                                            head: {
                                                view: 'toolbar',
                                                cols: [
                                                    {
                                                        view: 'label',
                                                        label: 'Soporte', // Window title
                                                    },
                                                    {
                                                        view: 'button',
                                                        label: 'X', // Close button label
                                                        width: 100,
                                                        align: 'right',
                                                        click: "$$('windowfact2').close();", // Close window action
                                                    },
                                                ],
                                            },
                                            id: 'windowfact2', // Window ID
                                            modal: true, // Make the window modal
                                            position: 'center', // Center the window
                                            body: {
                                                rows: [
                                                    {
                                                        template:
                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>', // Iframe for PDF display
                                                    },
                                                ],
                                            },
                                        })
                                        .show(); // Show the window
                                    var reader = new FileReader(); // Create a FileReader instance
                                    reader.onload = function (event) {
                                        // On load event for the reader
                                        $$('pdf').clear(); // Clear previous PDF data
                                        $$('pdf').parse({
                                            data: event.target.result, // Parse the new PDF data
                                        });
                                    };

                                    // Function to convert base64 to Blob
                                    function b64toBlob(b64Data, contentType, sliceSize) {
                                        contentType = contentType || ''; // Default content type
                                        sliceSize = sliceSize || 512; // Default slice size
                                        var byteCharacters = atob(b64Data); // Decode base64 string
                                        var byteArrays = []; // Array to hold byte arrays
                                        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                                            var slice = byteCharacters.slice(offset, offset + sliceSize); // Slice the byte characters
                                            var byteNumbers = new Array(slice.length); // Create an array for byte numbers
                                            for (var i = 0; i < slice.length; i++) {
                                                byteNumbers[i] = slice.charCodeAt(i); // Convert characters to byte numbers
                                            }
                                            var byteArray = new Uint8Array(byteNumbers); // Create a Uint8Array from byte numbers
                                            byteArrays.push(byteArray); // Add to byte arrays
                                        }
                                        var blob = new Blob(byteArrays, {
                                            type: contentType, // Create a Blob with the specified content type
                                        });
                                        return blob; // Return the Blob
                                    }

                                    var contentType = 'application/pdf'; // Define content type for PDF
                                    var b64Data = data.Pdf; // Get base64 data from response
                                    var blob = b64toBlob(b64Data, contentType); // Convert base64 to Blob
                                    var file = window.URL.createObjectURL(blob); // Create a URL for the Blob
                                    console.log(blob); // Log the Blob for debugging
                                    document.querySelector('iframe').src = file; // Set the iframe source to the Blob URL
                                    var printWindow = window.open(
                                        file,
                                        '',
                                        'width=800,height=500', // Open a new window for printing
                                    );
                                    printWindow.print(); // Trigger print action
                                },
                            },
                        );
                },
            },
            on: {
                // Define event handlers for the datatable
                onBeforeLoad: function () {
                    // Before loading data
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                onAfterLoad: function () {
                    // After loading data
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            tooltip: true, // Enable tooltips
            math: true, // Enable math operations
            loadahead: 0, // Set load ahead option
            datafetch: devConfig.getDefaultDataFetch(), // Set default data fetch configuration
            pager: 'pagerA', // Set the pager ID for pagination
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view components and event handlers.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;

        // Define the API endpoint URL for fetching expenses
        var url = devConfig.geturlApi() + 'Accounting/GetExpenses';

        // Initialize an empty filter string
        var filter = '';

        // Initialize arrays to store data for various dropdowns
        var datePopup = [];
        var datePopup2 = [];
        var datePopup3 = [];
        var datePopup4 = [];

        // Initialize a variable to store the popup window for adding expenses
        var popupAdd = '';

        // Define the current date in the required format
        var createdLocalDate =
            webix.Date.add(new Date(), -0, 'day').getFullYear() +
            ':' +
            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
            ':' +
            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2);

        // Fetch BetShop data for the dropdown
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetBetShopSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Display an error message if the request fails
                    webix.message(_('Error! '));
                },
                success: function (text, data, XmlHttpRequest) {
                    // Parse the response and populate the datePopup array
                    var resp = JSON.parse(text);
                    for (var i = 0; i < resp.Data.length; i++) {
                        resp.Data[i].id = resp.Data[i].Id;
                        resp.Data[i].value = resp.Data[i].Name;
                    }
                    datePopup = resp.Data;

                    // Fetch CostCenter data for the dropdown
                    webix
                        .ajax()
                        .headers({
                            'Content-type': 'application/json',
                        })
                        .post(devConfig.geturlApi() + 'Accounting/GetCostCenterSelect', '', {
                            error: function (text, data, XmlHttpRequest) {
                                // Display an error message if the request fails
                                webix.message(_('Error! '));
                            },
                            success: function (text, data, XmlHttpRequest) {
                                // Parse the response and populate the datePopup2 array
                                var resp = JSON.parse(text);
                                datePopup2 = resp.Data;

                                // Fetch Concepts data for the dropdown
                                webix
                                    .ajax()
                                    .headers({
                                        'Content-type': 'application/json',
                                    })
                                    .post(devConfig.geturlApi() + 'Accounting/GetConceptsSelect', '', {
                                        error: function (text, data, XmlHttpRequest) {
                                            // Display an error message if the request fails
                                            webix.message(_('Error! '));
                                        },
                                        success: function (text, data, XmlHttpRequest) {
                                            // Parse the response and populate the datePopup3 array
                                            var resp = JSON.parse(text);
                                            datePopup3 = resp.Data;

                                            // Fetch TypesCenterPosition data for the dropdown
                                            webix
                                                .ajax()
                                                .headers({
                                                    'Content-type': 'application/json',
                                                })
                                                .post(
                                                    devConfig.geturlApi() + 'Accounting/GetTypesCenterPositionSelect',
                                                    '{"Type":2}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Display an error message if the request fails
                                                            webix.message(_('Error! '));
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {
                                                            // Parse the response and populate the datePopup4 array
                                                            var resp = JSON.parse(text);
                                                            datePopup4 = resp.Data;

                                                            // Create the popup window for adding expenses
                                                            popupAdd = webix.ui({
                                                                view: 'window',
                                                                width: 750,
                                                                id: 'AddExpenses',
                                                                head: {
                                                                    view: 'toolbar',
                                                                    cols: [
                                                                        {
                                                                            view: 'label',
                                                                            label: _('Añadir Gasto'),
                                                                        },
                                                                        {
                                                                            view: 'icon',
                                                                            icon: 'wxi-close',
                                                                            click: function () {
                                                                                this.getTopParentView().hide();
                                                                            },
                                                                        },
                                                                    ],
                                                                },
                                                                position: 'center',
                                                                modal: true,
                                                                body: {
                                                                    view: 'form',
                                                                    id: 'addform',
                                                                    elements: [
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'checkbox',
                                                                                    label: _('Es punto de venta?'),
                                                                                    name: 'IsBetShop',
                                                                                    value: 1,
                                                                                    labelWidth: 140,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Descripción'),
                                                                                    name: 'Description',
                                                                                    labelWidth: 140,
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Fecha de Creación'),
                                                                                    labelWidth: 140,
                                                                                    name: 'CreatedLocalDate',
                                                                                    value: createdLocalDate,
                                                                                    readonly: true,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Tipo de Egreso'),
                                                                                    name: 'TypeEgress',
                                                                                    labelWidth: 140,
                                                                                    options: datePopup4,
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Punto de Venta'),
                                                                                    name: 'BetShop',
                                                                                    labelWidth: 140,
                                                                                    options: datePopup,
                                                                                    id: 'BetShop',
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Centro de costos'),
                                                                                    name: 'CostCenter',
                                                                                    labelWidth: 140,
                                                                                    options: datePopup2,
                                                                                    id: 'CostCenter',
                                                                                    hidden: true,
                                                                                    required: false,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'combo',
                                                                                    label: _('Concepto'),
                                                                                    name: 'Concept',
                                                                                    labelWidth: 140,
                                                                                    options: datePopup3,
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Documento ID'),
                                                                                    name: 'DocumentID',
                                                                                    labelWidth: 140,
                                                                                    required: false,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            margin: 10,
                                                                            cols: [
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Valor'),
                                                                                    name: 'Value',
                                                                                    type: 'number',
                                                                                    labelWidth: 100,
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Impuesto'),
                                                                                    name: 'Iva',
                                                                                    type: 'number',
                                                                                    labelWidth: 100,
                                                                                    required: true,
                                                                                },
                                                                                {
                                                                                    view: 'text',
                                                                                    label: _('Retracción'),
                                                                                    name: 'Retraccion',
                                                                                    type: 'number',
                                                                                    labelWidth: 100,
                                                                                    required: true,
                                                                                },
                                                                            ],
                                                                        },
                                                                        {
                                                                            cols: [
                                                                                {
                                                                                    view: 'button',
                                                                                    value: _('Cancelar'),
                                                                                    click: function () {
                                                                                        this.getTopParentView().hide();
                                                                                        $$('addform').setValues(
                                                                                            $(
                                                                                                'addform',
                                                                                            ).getCleanValues(),
                                                                                        );
                                                                                    },
                                                                                },
                                                                                {
                                                                                    view: 'button',
                                                                                    type: 'form',
                                                                                    value: _('Guardar'),
                                                                                    click: function ($e) {
                                                                                        var values =
                                                                                            $$('addform').getValues();
                                                                                        if ($$('addform').validate()) {
                                                                                            webix
                                                                                                .ajax()
                                                                                                .headers({
                                                                                                    'Content-type':
                                                                                                        'application/json',
                                                                                                })
                                                                                                .post(
                                                                                                    devConfig.geturlApi() +
                                                                                                        'Accounting/Expenses',
                                                                                                    '{"IsBetShop":"' +
                                                                                                        values.IsBetShop +
                                                                                                        '", "Description":"' +
                                                                                                        values.Description +
                                                                                                        '", "CreatedLocalDate":"' +
                                                                                                        values.CreatedLocalDate +
                                                                                                        '", "TypeEgress":"' +
                                                                                                        values.TypeEgress +
                                                                                                        '"  , "BetShop":"' +
                                                                                                        values.BetShop +
                                                                                                        '" , "CostCenter":"' +
                                                                                                        values.CostCenter +
                                                                                                        '" , "Concept":"' +
                                                                                                        values.Concept +
                                                                                                        '" , "DocumentID":"' +
                                                                                                        values.DocumentID +
                                                                                                        '"  , "Value":"' +
                                                                                                        values.Value +
                                                                                                        '", "Iva":"' +
                                                                                                        values.Iva +
                                                                                                        '", "Retraccion":"' +
                                                                                                        values.Retraccion +
                                                                                                        '"}',
                                                                                                    {
                                                                                                        error: function (
                                                                                                            text,
                                                                                                            data,
                                                                                                            XmlHttpRequest,
                                                                                                        ) {
                                                                                                            webix.message(
                                                                                                                _(
                                                                                                                    'Error! ',
                                                                                                                ),
                                                                                                            );
                                                                                                        },
                                                                                                        success:
                                                                                                            function (
                                                                                                                text,
                                                                                                                data,
                                                                                                                XmlHttpRequest,
                                                                                                            ) {
                                                                                                                webix.message(
                                                                                                                    _(
                                                                                                                        'Gasto Agregado',
                                                                                                                    ),
                                                                                                                );
                                                                                                                grid.clearAll();
                                                                                                                grid.load(
                                                                                                                    url +
                                                                                                                        '?start=0&count=' +
                                                                                                                        grid
                                                                                                                            .data
                                                                                                                            .$pagesize +
                                                                                                                        filter,
                                                                                                                );
                                                                                                                webix
                                                                                                                    .ui(
                                                                                                                        {
                                                                                                                            view: 'window',
                                                                                                                            width: 500,
                                                                                                                            height: 700,
                                                                                                                            head: {
                                                                                                                                view: 'toolbar',
                                                                                                                                cols: [
                                                                                                                                    {
                                                                                                                                        view: 'label',
                                                                                                                                        label: _(
                                                                                                                                            'Factura',
                                                                                                                                        ),
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                        view: 'button',
                                                                                                                                        label: 'X',
                                                                                                                                        width: 100,
                                                                                                                                        align: 'right',
                                                                                                                                        click: "$$('windowfact2').close();",
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                            id: 'windowfact2',
                                                                                                                            modal: true,
                                                                                                                            position:
                                                                                                                                'center',
                                                                                                                            body: {
                                                                                                                                rows: [
                                                                                                                                    {
                                                                                                                                        template:
                                                                                                                                            '<iframe src="" type="application/pdf" width="100%" height="100%" style="overflow: auto;"> </iframe>',
                                                                                                                                    },
                                                                                                                                ],
                                                                                                                            },
                                                                                                                        },
                                                                                                                    )
                                                                                                                    .show();
                                                                                                                var reader =
                                                                                                                    new FileReader();
                                                                                                                reader.onload =
                                                                                                                    function (
                                                                                                                        event,
                                                                                                                    ) {
                                                                                                                        $(
                                                                                                                            'pdf',
                                                                                                                        ).clear();
                                                                                                                        $(
                                                                                                                            'pdf',
                                                                                                                        ).parse(
                                                                                                                            {
                                                                                                                                data: event
                                                                                                                                    .target
                                                                                                                                    .result,
                                                                                                                            },
                                                                                                                        );
                                                                                                                    };

                                                                                                                function b64toBlob(
                                                                                                                    b64Data,
                                                                                                                    contentType,
                                                                                                                    sliceSize,
                                                                                                                ) {
                                                                                                                    contentType =
                                                                                                                        contentType ||
                                                                                                                        '';
                                                                                                                    sliceSize =
                                                                                                                        sliceSize ||
                                                                                                                        512;
                                                                                                                    var byteCharacters =
                                                                                                                        atob(
                                                                                                                            b64Data,
                                                                                                                        );
                                                                                                                    var byteArrays =
                                                                                                                        [];
                                                                                                                    for (
                                                                                                                        var offset = 0;
                                                                                                                        offset <
                                                                                                                        byteCharacters.length;
                                                                                                                        offset +=
                                                                                                                            sliceSize
                                                                                                                    ) {
                                                                                                                        var slice =
                                                                                                                            byteCharacters.slice(
                                                                                                                                offset,
                                                                                                                                offset +
                                                                                                                                    sliceSize,
                                                                                                                            );
                                                                                                                        var byteNumbers =
                                                                                                                            new Array(
                                                                                                                                slice.length,
                                                                                                                            );
                                                                                                                        for (
                                                                                                                            var i = 0;
                                                                                                                            i <
                                                                                                                            slice.length;
                                                                                                                            i++
                                                                                                                        ) {
                                                                                                                            byteNumbers[
                                                                                                                                i
                                                                                                                            ] =
                                                                                                                                slice.charCodeAt(
                                                                                                                                    i,
                                                                                                                                );
                                                                                                                        }
                                                                                                                        var byteArray =
                                                                                                                            new Uint8Array(
                                                                                                                                byteNumbers,
                                                                                                                            );
                                                                                                                        byteArrays.push(
                                                                                                                            byteArray,
                                                                                                                        );
                                                                                                                    }
                                                                                                                    var blob =
                                                                                                                        new Blob(
                                                                                                                            byteArrays,
                                                                                                                            {
                                                                                                                                type: contentType,
                                                                                                                            },
                                                                                                                        );
                                                                                                                    return blob;
                                                                                                                }

                                                                                                                var contentType =
                                                                                                                    'application/pdf';
                                                                                                                var b64Data =
                                                                                                                    data.Pdf;
                                                                                                                var blob =
                                                                                                                    b64toBlob(
                                                                                                                        b64Data,
                                                                                                                        contentType,
                                                                                                                    );
                                                                                                                var file =
                                                                                                                    window.URL.createObjectURL(
                                                                                                                        blob,
                                                                                                                    );
                                                                                                                console.log(
                                                                                                                    blob,
                                                                                                                );
                                                                                                                document.querySelector(
                                                                                                                    'iframe',
                                                                                                                ).src =
                                                                                                                    file;
                                                                                                                var printWindow =
                                                                                                                    window.open(
                                                                                                                        file,
                                                                                                                        '',
                                                                                                                        'width=800,height=500',
                                                                                                                    );
                                                                                                                printWindow.print();
                                                                                                            },
                                                                                                    },
                                                                                                );
                                                                                            $$('addform').setValues(
                                                                                                $(
                                                                                                    'addform',
                                                                                                ).getCleanValues(),
                                                                                            );
                                                                                            this.getTopParentView().hide();
                                                                                        } else {
                                                                                            webix.message({
                                                                                                title: _('¡Error!'),
                                                                                                type: 'alert-error',
                                                                                                text: _(
                                                                                                    'Completa los campos...',
                                                                                                ),
                                                                                            });
                                                                                        }
                                                                                    },
                                                                                },
                                                                            ],
                                                                        },
                                                                    ],
                                                                    elementsConfig: {
                                                                        on: {
                                                                            onChange: function () {
                                                                                if (this.getValue() == '1') {
                                                                                    $$('CostCenter').hide();
                                                                                    $$('BetShop').show();
                                                                                } else {
                                                                                    if (this.getValue() == '0') {
                                                                                        $$('CostCenter').show();
                                                                                        $$('BetShop').hide();
                                                                                    }
                                                                                }
                                                                                this.validate();
                                                                            },
                                                                        },
                                                                    },
                                                                },
                                                            });
                                                        },
                                                    },
                                                );
                                        },
                                    });
                            },
                        });
                },
            });

        // Event listener for the 'expense:filter' event on the app instance
        this.on(this.app, 'expense:filter', (filterData) => {
            // Convert filterData object into an array of key-value pairs
            var object = Object.entries(filterData);
            var string1 = ''; // Initialize an empty query string

            // Iterate through each key-value pair in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and is not an empty string
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle the 'Datepicker' case
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        // Handle other cases except for 'Date'
                        if (object[i][0] != 'Date') {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add key-value pair to query
                        } else {
                            // Handle the 'Date' case specifically
                            if (object[i][0] == 'Date') {
                                var date = object[i][1].replace(
                                    ' 00:00:00',
                                    '', // Remove time from date string
                                );
                                string1 = string1 + '&dateFrom=' + date; // Add date to query
                                string1 = string1 + '&dateTo=' + date; // Add date to query
                            }
                        }
                    }
                } else {
                    // Handle cases where the value is an object
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to array
                        // Iterate through each key-value pair in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle 'start' date case
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create a Date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() + // Format year
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) + // Format day
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) + // Format hours
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format seconds
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    // Handle 'end' date case
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create a Date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() + // Format year
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) + // Format month
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) + // Format day
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) + // Format hours
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) + // Format minutes
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format seconds
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid before loading new data
            // Load data into the grid with the constructed query string
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1; // Store the constructed filter string
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Attach an event handler for the 'onItemClick' event of the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Get the clicked item from the grid
            var item = this.getItem(id);
            // Trigger a custom event with the item's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });

        // Listen for the 'player:select' event from the app
        this.on(this.app, 'player:select', (Id) => {
            // Load grid data filtered by PlayerId
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id);
        });

        // Create a popup window for editing expenses
        var popup = webix.ui({
            view: 'window',
            width: 750,
            id: 'EditExpenses',
            head: {
                view: 'toolbar',
                cols: [
                    // Label for the popup header
                    { view: 'label', label: _('Editar Gasto') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the popup when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'form',
                id: 'editForm',
                elements: [
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'checkbox',
                                label: _('Es punto de venta?'),
                                name: 'IsBetShop',
                                id: 'IsBetShop',
                                labelWidth: 140,
                                readonly: true, // Checkbox is read-only
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: 'ID',
                                name: 'Id',
                                readonly: true, // ID field is read-only
                                labelWidth: 140,
                            },
                            {
                                view: 'text',
                                label: _('Descripción'),
                                name: 'Description',
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Fecha de Creación'),
                                labelWidth: 140,
                                name: 'CreatedLocalDate',
                                readonly: true, // Creation date field is read-only
                            },
                            {
                                view: 'text',
                                label: _('Tipo de Egreso'),
                                name: 'TypeEgress',
                                readonly: true, // Egress type field is read-only
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Documento ID'),
                                name: 'DocumentID',
                                readonly: true, // Document ID field is read-only
                                labelWidth: 140,
                            },
                            {
                                view: 'combo',
                                label: _('Punto de Venta'),
                                name: 'BetShop',
                                labelWidth: 140,
                                readonly: true, // BetShop field is read-only
                                id: 'BetShop',
                            },
                            {
                                view: 'combo',
                                label: _('Centro de costos'),
                                name: 'CostCenter',
                                labelWidth: 140,
                                readonly: true, // CostCenter field is read-only
                                id: 'CostCenter',
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'combo',
                                label: _('Concepto'),
                                name: 'Concept',
                                labelWidth: 140,
                                readonly: true, // Concept field is read-only
                            },
                            {
                                view: 'text',
                                label: _('Valor'),
                                name: 'Value',
                                type: 'number', // Value field is a number input
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        margin: 10,
                        cols: [
                            {
                                view: 'text',
                                label: _('Impuesto'),
                                name: 'Iva',
                                type: 'number', // Tax field is a number input
                                labelWidth: 140,
                            },
                            {
                                view: 'text',
                                label: _('Retracción'),
                                name: 'Retraccion',
                                type: 'number', // Retraction field is a number input
                                labelWidth: 140,
                            },
                        ],
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                // Cancel button to hide the popup and reset form
                                click: function () {
                                    this.getTopParentView().hide();
                                    $$('editForm').setValues($$('editForm').getCleanValues());
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                // Save button to submit the form data
                                click: function ($e) {
                                    var values = $$('editForm').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Accounting/Expenses',
                                            '{"Id":"' +
                                                values.Id +
                                                '", "IsBetShop":"' +
                                                values.IsBetShop +
                                                '", "Description":"' +
                                                values.Description +
                                                '", "CreatedLocalDate":"' +
                                                values.CreatedLocalDate +
                                                '", "TypeEgress":"' +
                                                values.TypeEgress +
                                                '"  , "CostCenter":"' +
                                                values.CostCenter +
                                                '"  , "BetShop":"' +
                                                values.BetShop +
                                                '"  , "DocumentID":"' +
                                                values.DocumentID +
                                                '"  , "Value":"' +
                                                values.Value +
                                                '", "Iva":"' +
                                                values.Iva +
                                                '", "Retraccion":"' +
                                                values.Retraccion +
                                                '"}',
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Gasto Actualizado'));
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter); // Reload grid data
                                                },
                                            },
                                        );
                                    $$('editForm').setValues($$('editForm').getCleanValues());
                                    this.getTopParentView().hide(); // Hide the popup after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'AddExpense:button' event on the application
        this.on(this.app, 'AddExpense:button', (filter) => {
            // Check if all date popups have values
            if (datePopup.length > 0 && datePopup2.length > 0 && datePopup3.length > 0 && datePopup2.length > 0) {
                // Clear any previous validation errors on the add form
                $$('addform').clearValidation();
                // Show the add expense popup
                popupAdd.show();
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Listen for the 'openEdit' event on the application
        this.on(this.app, 'openEdit', (filterData) => {
            // Check if all date popups have values
            if (datePopup.length > 0 && datePopup2.length > 0 && datePopup3.length > 0 && datePopup2.length > 0) {
                // Show the edit popup
                popup.show();
            } else {
                // Display an error message if data could not be loaded
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });

        // Bind the edit form to the data table
       $$('editForm').bind($$('datatable'));

        // Attach an event listener for when the 'EditExpenses' element gains focus
        $$('EditExpenses').attachEvent('onFocus', function () {
            // Delay the execution of the following function
            webix.delay(
                function () {
                    // Check if the 'IsBetShop' value is 1
                    if ($$('IsBetShop').getValue() == 1) {
                        // Hide the CostCenter element and show the BetShop element
                        $$('CostCenter').hide();
                        $$('BetShop').show();
                    } else {
                        // Check if the 'IsBetShop' value is 0
                        if ($$('IsBetShop').getValue() == 0) {
                            // Show the CostCenter element and hide the BetShop element
                            $$('CostCenter').show();
                            $$('BetShop').hide();
                        }
                    }
                },
                '', // No context
                '', // No parameters
                50, // Delay of 50 milliseconds
            );
        }); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
